import React from 'react';
import { Link } from 'react-router-dom';
import VastuLensLogo from './VastuLensLogo';

// --- Social Media Icons ---
const SocialIcon = ({ href, children }) => (
    <a href={href} target="_blank" rel="noopener noreferrer" style={{ color: 'white', opacity: 0.8, transition: 'opacity 0.3s' }}>
        {children}
    </a>
);
const FacebookIcon = () => (<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path></svg>);
const TwitterIcon = () => (<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path></svg>);
const InstagramIcon = () => (<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><rect width="20" height="20" x="2" y="2" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>);


function Footer() {
  return (
    <footer style={{
      backgroundColor: 'var(--color-text)',
      color: 'white',
      padding: '4rem 0 2rem',
      marginTop: 'auto'
    }}>
      <div className="container">
        <div style={{
          display: 'grid',
          gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr',
          gap: '2rem',
          marginBottom: '3rem',
          paddingBottom: '3rem',
          borderBottom: '1px solid rgba(255,255,255,0.1)'
        }}>
          {/* Column 1: About */}
          <div style={{maxWidth: '350px'}}>
            <VastuLensLogo height={35} color="white" />
            <p style={{ opacity: 0.8, lineHeight: 1.7, marginTop: '1.5rem' }}>
              Combining ancient Vedic wisdom with modern AI to bring harmony and positive energy to your living spaces.
            </p>
          </div>
          
          {/* Column 2: Quick Links */}
          <div>
            <h4 style={footerHeadingStyle}>Navigate</h4>
            <ul style={footerListStyle}>
              <li><Link to="/" style={footerLinkStyle}>Home</Link></li>
              <li><Link to="/analysis" style={footerLinkStyle}>Get Analysis</Link></li>
              <li><Link to="/about" style={footerLinkStyle}>About</Link></li>
            </ul>
          </div>

          {/* Column 3: Resources */}
          <div>
            <h4 style={footerHeadingStyle}>Resources</h4>
            <ul style={footerListStyle}>
              <li><Link to="/blog" style={footerLinkStyle}>Knowledge Base</Link></li>
              <li><Link to="/methodology" style={footerLinkStyle}>How We Score</Link></li>
              <li><Link to="/compare" style={footerLinkStyle}>Compare Properties</Link></li>
              <li><Link to="/business" style={footerLinkStyle}>For Business</Link></li>
            </ul>
          </div>

          {/* Column 4: Company */}
          <div>
            <h4 style={footerHeadingStyle}>Company</h4>
            <ul style={footerListStyle}>
              <li><Link to="/about" style={footerLinkStyle}>About</Link></li>
            </ul>
          </div>

          {/* Column 5: Social */}
          <div>
            <h4 style={footerHeadingStyle}>Connect</h4>
            <div style={{ display: 'flex', gap: '1.5rem', marginTop: '1rem' }}>
                <SocialIcon href="https://facebook.com"><FacebookIcon /></SocialIcon>
                <SocialIcon href="https://twitter.com"><TwitterIcon /></SocialIcon>
                <SocialIcon href="https://instagram.com"><InstagramIcon /></SocialIcon>
            </div>
          </div>
        </div>
        
        <div style={{ textAlign: 'center', opacity: 0.7 }}>
          <p>© {new Date().getFullYear()} VastuLens. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
}

const footerHeadingStyle = {
    color: 'white',
    marginBottom: '1.5rem',
    fontSize: '1.1rem',
    fontWeight: '600',
    opacity: 0.9,
};

const footerListStyle = {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
};

const footerLinkStyle = {
  color: 'white',
  textDecoration: 'none',
  opacity: 0.8,
  transition: 'opacity 0.3s',
};


export default Footer;